import { fetchProductPricingQueryFn } from './fetch-product-pricing.query';
export const fetchCyclePricingQueryFn = async props => {
  const {
    httpClient,
    request: {
      productId,
      cycleId
    }
  } = props;
  const {
    cyclePricingItems
  } = await fetchProductPricingQueryFn({
    httpClient,
    request: {
      productId
    }
  });
  const cyclePricing = cyclePricingItems.find(item => item.cycleId === cycleId);
  return {
    cyclePricing
  };
};
//# sourceMappingURL=fetch-cycle-pricing.query.js.map